import React from "react";
import { useTranslation } from "react-i18next";
import "./detail-balance-content.scss";
import ShowContainer from "../../../mui/ShowContainer";
import WarningInfo from "../../../mui/warning_info/WarningInfo";
import BalanceStepper from "./BalanceStepper";

const DetailBalanceContent = ({
  currency = "",
  mainBalance = "",
  bonusBalance = "",
  openMain = "",
  detailBonusBalance = [],
  detailDepositBalance = [],
  className = ""
}) => {
  const { t } = useTranslation();
  const rootClassName = ["balance-breakdown", className].filter(Boolean).join(" ");

  const isFullOpenMain = openMain == mainBalance;
  const isShowWagerInfo = detailBonusBalance.length || detailBonusBalance.length;

  return (
    <div className={rootClassName}>
      <div className="balance-breakdown__section">
        <div className="balance-breakdown__label">{t("Main balance")}</div>

        <div className="balance-breakdown__main-row">
          <div className="balance-breakdown__amount balance-breakdown__amount--main">
            {mainBalance}
            <span className="balance-breakdown__currency">{currency}</span>
          </div>
          <ShowContainer condition={openMain}>
            <span className="balance-breakdown__status-pill">
              {t("Open for payment")}
              <span className="accent">{!isFullOpenMain && `${openMain} ${currency}`}</span>
            </span>
          </ShowContainer>
        </div>
        <BalanceStepper details={detailDepositBalance} currency={currency} />
      </div>

      <ShowContainer condition={detailBonusBalance.length}>
        <div className="balance-breakdown__section">
          <div className="balance-breakdown__label">{t("Bonus balance")}</div>

          <div className="balance-breakdown__amount balance-breakdown__amount--bonus">
            {bonusBalance}
            <span className="balance-breakdown__currency">{currency}</span>
          </div>

          <BalanceStepper details={detailBonusBalance} currency={currency} />
        </div>
      </ShowContainer>

      <ShowContainer condition={isShowWagerInfo}>
        <WarningInfo>
          {t(
            "The amounts are shown from top to bottom, in the order in which the bet would be placed per spin in the game."
          )}
        </WarningInfo>
      </ShowContainer>
    </div>
  );
};

export default DetailBalanceContent;
